<template>
    <div class="flex">
      <div
        class="option-box mr-2"
        :class="{ 'bg-primary selected': value === true }"
        @click="updateValue(true)"
      >
        <slot name="yes">Yes</slot>
      </div>
      <div
        class="option-box"
        :class="{ 'bg-primary selected': value === false }"
        @click="updateValue(false)"
      >
        <slot name="no">No</slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      value: Boolean, // v-model will bind to "value" in Vue 2
      disabled: Boolean,
    },
    methods: {
      updateValue(selectedValue) {
        if (!this.disabled) {
          this.$emit("input", selectedValue);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .option-box {
    padding: 5px 10px;
    border: 2px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    min-width: 50px;
    transition: all 0.3s;
  }
  
  .option-box.selected {
    color: rgb(251, 251, 251);
  }
  
  .option-box:hover {
    background-color: #e0e0e0;
  }
  </style>
  